// extracted by mini-css-extract-plugin
module.exports = {"emails":"Emails_emails__owWpV","title":"Emails_title__yMKqg","email-container":"Emails_email-container__RrWlO","emailContainer":"Emails_email-container__RrWlO"};